const ENABLE_DAI_DISPUTE_ANALYSIS_TAG = 'enable_dai_dispute_analysis'

const SETTING_TAGS = {
  ENABLE_DAI_DISPUTE_ANALYSIS: ENABLE_DAI_DISPUTE_ANALYSIS_TAG,
}

export default {
  ENABLE_DAI_DISPUTE_ANALYSIS_TAG,
  SETTING_TAGS,
}
